import React from 'react'
import AuthenticationContainer from '../containers/AuthenticationProvider/AuthenticationProvider.container'
import UniquePassAuthContainer from '../containers/UniquePassAuth/UniquePassAuth.container'

/**
 * The UniquePassAuth's page.
 */
const UniquePassAuth = () => {
  return (
    <AuthenticationContainer>
      <UniquePassAuthContainer />
    </AuthenticationContainer>
  )
}

export default UniquePassAuth
